'use client';

import { c as _c } from "react/compiler-runtime";
import type { ComponentProps, PropsWithChildren, Ref } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import { Controls } from '@/components/Zoomable/Controls';
import { cn } from '@/lib/cn';
export interface ZoomableProps extends PropsWithChildren {
  className?: string;
  contentProps?: Omit<ComponentProps<typeof TransformComponent>, 'children'>;
  controls?: boolean;
  ready?: boolean;
  ref?: Ref<HTMLDivElement>;
  wrapperProps?: ComponentProps<typeof TransformWrapper>;
}
const defaultWrapper: Partial<ComponentProps<typeof TransformWrapper>> = {
  centerOnInit: true
};
const defaultContent: Partial<ComponentProps<typeof TransformComponent>> = {
  wrapperClass: 'h-full w-full'
};
export function Zoomable(t0) {
  const $ = _c(12);
  const {
    children,
    className,
    contentProps,
    controls: t1,
    ready: t2,
    ref,
    wrapperProps
  } = t0;
  const controls = t1 === undefined ? true : t1;
  const ready = t2 === undefined ? true : t2;
  let t3;
  if ($[0] !== className) {
    t3 = cn("relative w-full h-full", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== contentProps || $[4] !== controls || $[5] !== ready || $[6] !== wrapperProps) {
    t4 = ready ? <TransformWrapper {...{
      ...defaultWrapper,
      ...wrapperProps
    }}>{controls ? <Controls /> : null}<TransformComponent {...{
        ...defaultContent,
        ...contentProps
      }} wrapperClass="w-full h-full">{children}</TransformComponent></TransformWrapper> : null;
    $[2] = children;
    $[3] = contentProps;
    $[4] = controls;
    $[5] = ready;
    $[6] = wrapperProps;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== ref || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className={t3} ref={ref}>{t4}</div>;
    $[8] = ref;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}